import React from "react";
import { Box } from "@mui/material";

const PALETTE = [
  "#6366F1", "#0EA5E9", "#10B981", "#F59E0B",
  "#EF4444", "#8B5CF6", "#EC4899", "#14B8A6",
];

const colorFor = (seed: string) => {
  const sum = (seed || "?").split("").reduce((a, c) => a + c.charCodeAt(0), 0);
  return PALETTE[sum % PALETTE.length];
};

const initialsOf = (name: string) =>
  (name || "?")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase() || "?";

interface Props {
  name: string;
  size?: number;
}

/** Deterministic colored initials avatar (rounded square). */
const InitialsAvatar: React.FC<Props> = ({ name, size = 38 }) => {
  const color = colorFor(name);
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: `${Math.round(size * 0.28)}px`,
        bgcolor: `${color}1A`,
        color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 800,
        fontSize: size * 0.36,
        flexShrink: 0,
        letterSpacing: "-0.5px",
      }}
    >
      {initialsOf(name)}
    </Box>
  );
};

export default InitialsAvatar;
